import * as React from 'react'

import { StyledVerticalSpacer } from './ClinSpacer.styles'
import { ClinTheme } from '../../ClinTheme'
import { IDefaultStyleProps } from '../../types'

export interface IVerticalSpacerStyles {
  /** The height of the spacer */
  height?: number | string
  /** Displays a border middle */
  hasBorder?: boolean
  /** Set z-index */
  zIndex?: string
  /** Custom style */
  style?: object
  /** Custom color */
  color?: string
  width?: string
  top?: string
}

interface IVerticalSpacerProps
  extends IDefaultStyleProps,
    IVerticalSpacerStyles {}

export const ClinSpacer: React.FC<IVerticalSpacerProps> = ({
  className = '',
  style,
  height = ClinTheme.space[3],
  hasBorder = false,
  zIndex = 'unset',
  color = '',
  width = '',
  top = ''
}) => (
  <StyledVerticalSpacer
    className={`clin-vertical-spacer ${className}`}
    height={height}
    style={style}
    hasBorder={hasBorder}
    zIndex={zIndex}
    color={color}
    width={width}
    top={top}
  />
)
